import { BidPanel } from './components/BidPanel/BidPanel';
import { CurrencyCode } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';
import { ItemDetails } from './components/ItemDetails/ItemDetails';

type Props = {
    itemId: number;
    selectedCurrency?: CurrencyCode;
};

export const BiddingConsoleMiddleSection = ({ itemId, selectedCurrency }: Props) => {
    return (
        <div className="grid h-[calc(100vh-64px)] grid-rows-[1fr_min-content] rounded-sm border border-border-secondary">
            <ItemDetails itemId={itemId} />
            <BidPanel
                itemId={itemId}
                selectedCurrency={selectedCurrency}
            />
        </div>
    );
};
